import React, { Component } from 'react'

import Layout from 'containers/Layout'
import MainMenu from 'containers/MainMenu'

export class CanopyMainPage extends Component {
  render() {
    return (
      <Layout isFullNavbar={true} isSidebar={true}>
        <MainMenu />
      </Layout>
    )
  }
}

export default CanopyMainPage
